import React, { useMemo } from 'react'
import { Campaign } from '../models/shared/Campaign'
import { Card, IconButton } from '@wix/design-system'
import { useNavigation } from '../context/NavigationContext'
import { Preview } from '@wix/wix-ui-icons-common'
import { AnalyticsDateRange, DEFAULT_DATE_RANGE } from '../models/AnalyticsDateRange'
import { useFirebaseQueryOptions } from '../hooks/firebaseHooks'
import { ResponseModel } from '../models/shared/ResponseModel'
import { Collections } from '../utils/shared/constants'
import { where } from 'firebase/firestore'
import { calculateResults } from '../utils/logic'
import AnalyticsHighlights from './AnalyticsHighlights'
import DateRangePicker from './DateRangePicker'

interface Props {
    campaign: Campaign
}

function CampaignAnalyticsHighligtsCard(props: Props) {
    const { campaign } = props
    const { navigate } = useNavigation();
    const [dateRange, setDateRange] = React.useState<AnalyticsDateRange>(DEFAULT_DATE_RANGE);
    const [responses] = useFirebaseQueryOptions<ResponseModel>(`${Collections.campaigns}/${campaign.id}/${Collections.responses}`,
        {
            queryConstraints: [
                where('createdAt', '>=', dateRange.compareFrom),
                where('createdAt', '<=', dateRange.to)
            ],
            dependencies: [dateRange.compareFrom, dateRange.to]
        }
    )
    const responseResults = useMemo(() => calculateResults(responses, dateRange), [responses, dateRange]);

    return <Card>
        <Card.Header
            title="Highlights"
            subtitle={`See results for the active campaign - ${campaign.name}`}
            suffix={
                <div className='d-flex align-items-center'>
                    <DateRangePicker dateRange={dateRange} setDateRange={setDateRange} simplified />
                    <IconButton priority='secondary' size='small'
                        className='ms-2'
                        onClick={() => navigate('responses', { id: campaign.id || '' })}>
                        <Preview />
                    </IconButton>
                </div>}
        />
        <div className='p-4'>

            <AnalyticsHighlights responseResults={responseResults} />
        </div>
    </Card>
}

export default CampaignAnalyticsHighligtsCard
